import * as React from 'react'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { Loader } from 'shared/components/Loader'
import { IApplicationState } from 'redux/store/store'
import { VestigingEnum, SortVolgordeEnum } from 'shared/models/Enum'
import { IKlantSelectie } from 'shared/models/IKlantSelectie'
import {
  IGetKlantKoppelingResponseAction,
  getDataActionCreator,
  IPostKlantKoppelingResponseAction,
  deleteKlantgroepAfleverafspraakActionCreator,
  IDeleteKlantgroepAfleverafspraakResponseAction,
  getKlantGroepenVestiging,
  getKlantGegevens,
  IGetKlantGegevensResponseAction,
  IGetKlantGroepenVestigingResponseAction,
  postKlantGroepAfleverafspraakActionCreator,
  getKlantAfleverafspraken,
} from 'redux/store/actions/klantKoppelingAction'
import { useState, useEffect } from 'react'
import { Modal, Button, Table } from 'react-bootstrap'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import SelectieButton, {
  SelectieDescriptor,
} from 'shared/components/SelectieButton'
import { Redirect } from 'react-router'
import { IKlant } from 'shared/models/IKlant'
import { selectDay } from 'shared/service/helpers/DateUtilities'
import { IOrderType } from 'shared/models/IOrderType'
import { IKlantgroepAfleverafspraakModel } from 'shared/models/IKlantgroepAfleverafspraakModel'
import { IGetKlantAfleverafsprakenVestigingResponseAction } from './../../redux/store/actions/klantKoppelingAction'
import { format } from 'date-fns'
import {
  getPossibleOrderTypesActionCreator,
  ISetPossibleOrderTypesResponseAction,
} from 'redux/store/actions/globalAction'

const regexKlantnummer = /[^0-9]/gi

interface IProps {
  selectie: IKlantSelectie
  requestData: (
    selectie: IKlantSelectie
  ) => Promise<IGetKlantKoppelingResponseAction>
  postData: (
    klantgroep: IKlantgroepAfleverafspraakModel
  ) => Promise<IPostKlantKoppelingResponseAction>
  verwijderData: (
    klantgroep: IKlantgroepAfleverafspraakModel
  ) => Promise<IDeleteKlantgroepAfleverafspraakResponseAction>
  getklantgegevens: (
    klantnummer: number
  ) => Promise<IGetKlantGegevensResponseAction>
  getklantafleverafspraken: (
    vestiging: VestigingEnum,
    klantnummer: number
  ) => Promise<IGetKlantAfleverafsprakenVestigingResponseAction>
  getklantgroepen: (
    vestiging: VestigingEnum
  ) => Promise<IGetKlantGroepenVestigingResponseAction>
  getPossibleOrderTypes: () => Promise<ISetPossibleOrderTypesResponseAction>
  koppelingen: IKlantgroepAfleverafspraakModel[]
  koppeling: IKlantgroepAfleverafspraakModel
  klantafleverafspraken: SelectieDescriptor[]
  klantGroepen: SelectieDescriptor[]
  alleklantGroepen: IKlantGroepModel[]
  schermloading: boolean
  foutmelding: string
  koppelklant: IKlant
  globalVestiging: VestigingEnum
  possibleOrderTypes: IOrderType[]
  loadingPossibleOrderTypes: boolean
}

const KlantKoppelingenLijst: React.FunctionComponent<IProps> = ({
  globalVestiging,
  selectie = {
    afleverAfspraakId: undefined,
    afleverAfspraakReferentie: '',
    klantNummer: undefined,
    vestiging: globalVestiging,
    klantNaam: '',
    klantGroepId: undefined,
  },
  requestData,
  postData,
  verwijderData,
  getklantgegevens,
  getklantafleverafspraken,
  getklantgroepen,
  getPossibleOrderTypes,
  schermloading,
  foutmelding,
  klantafleverafspraken,
  klantGroepen,
  alleklantGroepen,
  koppelingen,
  koppeling,
  koppelklant,
  possibleOrderTypes,
  loadingPossibleOrderTypes,
}) => {
  useEffect(() => {
    setVestiging(globalVestiging)
  }, [globalVestiging])

  const [show, setShow] = useState(false)
  const [huidigeKoppeling, setHuidigeKoppeling] =
    useState<IKlantgroepAfleverafspraakModel>(koppeling)
  const [opgeslagen, setOpgeslagen] = useState(false)
  const [klantNaam, setKlantNaam] = useState(undefined)
  const [zoekKlantNummer, setZoekKlantnummer] = useState<number>()
  const [sortOrder, setSortOrder] = useState(SortVolgordeEnum.KlantNummer)
  const [activeGroup, setActiveGroup] = useState<IKlantGroepModel>()

  useEffect(() => {
    getPossibleOrderTypes()
  }, [getPossibleOrderTypes])

  useEffect(() => {
    if (koppelklant != null) {
      setHuidigeKoppeling(prevValue => ({
        ...prevValue,
        klantId: koppelklant.klantId,
        klantEanNummer: koppelklant.klantEanCode,
        klantNaam: koppelklant.klantNaam,
        klantNummer: koppelklant.klantNummer,
      }))
    }
  }, [koppelklant])

  const handleClose = () => {
    setShow(false)
    setActiveGroup(null)
    setZoekKlantnummer(null)
    selectie.vestiging = globalVestiging
    requestData(selectie)
  }
  const handleShow = () => {
    setShow(true)
  }

  const setSort = (i: SortVolgordeEnum) => {
    setSortOrder(i)
  }

  const setKlantNummer = e => {
    selectie.klantNummer = e.target.value.replace(regexKlantnummer, '')
  }

  const setAfleverAfspraakReferentie = e => {
    selectie.afleverAfspraakReferentie = e.target.value
  }

  const setDetailZoekKlantNummer = e => {
    setZoekKlantnummer(e.target.value.replace(regexKlantnummer, ''))
  }

  const setVestiging = (i: VestigingEnum) => {
    getklantgroepen(i)
  }

  const setSelectieKlantgroep = i => {
    selectie.klantGroepId = i.target.value
  }

  const setDetailAfleverafspraakReferentie = i => {
    const value = i.target.value
    if (value >= 0 && value != undefined) {
      setHuidigeKoppeling(prevValue => ({
        ...prevValue,
        klantAfleverAfspraakId: Number.parseInt(value),
      }))
    } else {
      setHuidigeKoppeling(prevValue => ({
        ...prevValue,
        klantAfleverAfspraakId: 0,
      }))
    }
  }

  const clearDetailKlantgroep = () => {
    setHuidigeKoppeling(prevValue => ({
      ...prevValue,
      klantGroepId: undefined,
      klantGroepCode: undefined,
      klantGroepOmschrijving: undefined,
    }))
    setActiveGroup(undefined)
  }

  const setDetailKlantgroep = i => {
    // NaN > 0 is false
    const parsedKlantGroepId = parseInt(i.target.value, 10)
    const gekozengroep: IKlantGroepModel | undefined =
      parsedKlantGroepId > 0
        ? alleklantGroepen.find(
            t =>
              t.vestigingCode == globalVestiging &&
              t.klantGroepId === parsedKlantGroepId
          )
        : undefined

    if (!gekozengroep) {
      clearDetailKlantgroep()
      return
    }

    setHuidigeKoppeling(prevValue => ({
      ...prevValue,
      klantGroepId: gekozengroep.klantGroepId,
      klantGroepCode: gekozengroep.klantGroepCode,
      klantGroepOmschrijving: gekozengroep.klantGroepOmschrijving,
    }))
    setActiveGroup(gekozengroep)
  }

  const selectKlantNaam = x => {
    selectie.klantNaam = x.target.value
    setKlantNaam(x.target.value) //TODO: truukje om component te laten updaten, betere oplossing vinden (moet via redux)
  }

  const zoekKlantGroepenIfEnter = (e: string) => {
    if (e === 'Enter') {
      zoekKlantGroepen()
    }
  }

  const zoekKlantGroepen = () => {
    selectie.vestiging = globalVestiging
    console.log('Geselecteerde vestiging: ', selectie.vestiging)
    requestData(selectie)
  }

  const sortedData = (
    data: IKlantgroepAfleverafspraakModel[]
  ): IKlantgroepAfleverafspraakModel[] => {
    switch (sortOrder) {
      case SortVolgordeEnum.AfleverafspraakReferentie:
        return data.sort((a, b) =>
          a.afleverAfspraakReferentie.localeCompare(b.afleverAfspraakReferentie)
        )
      case SortVolgordeEnum.KlantGroep:
        return data.sort((a, b) => a.klantGroepCode - b.klantGroepCode)
      case SortVolgordeEnum.Vestiging:
        return data.sort((a, b) => a.vestiging - b.vestiging)
      case SortVolgordeEnum.KlantEan:
        return data.sort((a, b) => a.klantEanNummer - b.klantEanNummer)
      case SortVolgordeEnum.KlantNaam:
        return data.sort((a, b) =>
          a.klantNaam > b.klantNaam ? 1 : b.klantNaam > a.klantNaam ? -1 : 0
        )
      case SortVolgordeEnum.MutatieDatumTijd:
        return data.sort((a, b) =>
          new Date(a.mutatieDatumTijd) < new Date(b.mutatieDatumTijd) ? 1 : -1
        )
      case SortVolgordeEnum.MutatieGebruiker:
        return data.sort((a, b) =>
          a.mutatieGebruiker > b.mutatieGebruiker
            ? 1
            : b.mutatieGebruiker > a.mutatieGebruiker
            ? -1
            : 0
        )
      default:
        return data.sort((a, b) => a.klantNummer - b.klantNummer)
    }
  }

  const renderRows = (data: IKlantgroepAfleverafspraakModel[]) => {
    return sortedData(data).map(x => {
      return (
        <tr key={x.klantgroepAfleverafspraakId} onClick={() => showDetail(x)}>
          <td className='tddata'>{x.afleverAfspraakReferentie}</td>
          <td className='tddata'>{x.klantNummer}</td>
          <td className='tddata'>{x.klantEanNummer}</td>
          <td className='tddata mw-200 overflow-hidden' title={x.klantNaam}>
            {x.klantNaam}
          </td>
          <td className='tddata'>{x.vestiging}</td>
          <td className='tddata'>
            {x.klantGroepCode}-{x.klantGroepOmschrijving}
          </td>
          <td className='tddata'>{formatDate(x.mutatieDatumTijd)}</td>
          <td className='tddata'>{x.mutatieGebruiker}</td>
        </tr>
      )
    })
  }

  const formatDate = date => {
    const dateTime = Date.parse(date)
    return format(dateTime, 'yyyy-MM-dd HH:mm')
  }

  const showDetail = (data: IKlantgroepAfleverafspraakModel) => {
    setOpgeslagen(false)
    let detailResult: Promise<IGetKlantGroepenVestigingResponseAction>
    if (data.klantNummer > 0) {
      detailResult = getklantafleverafspraken(
        data.vestiging,
        data.klantNummer
      ).then(() => getklantgroepen(data.vestiging))
    } else {
      detailResult = getklantgroepen(data.vestiging)
    }
    detailResult
      .then(() => setHuidigeKoppeling(data))
      .then(() => {
        handleShow()
        var vestiginggroepen = alleklantGroepen.filter(
          f => f.vestigingCode == globalVestiging
        )
        var gekozengroep: IKlantGroepModel = vestiginggroepen.find(
          t => t.klantGroepId === data.klantGroepId
        )
        setActiveGroup(gekozengroep)
      })
  }

  const handleDelete = () => {
    console.log('handledelete')
    console.log(huidigeKoppeling)
    verwijderData(huidigeKoppeling).then(handleClose)
  }

  const zoekKlantIfEnter = (e: string) => {
    if (e === 'Enter') {
      zoekKlant()
    }
  }

  const zoekKlant = () => {
    if (zoekKlantNummer != undefined && zoekKlantNummer > 0) {
      getklantgegevens(zoekKlantNummer).then(result => {
        if (result.success) {
          getklantafleverafspraken(selectie.vestiging, zoekKlantNummer)
        }
      })
    }
  }

  const handleNieuw = () => {
    var nieuweKoppeling: IKlantgroepAfleverafspraakModel = {
      klantId: 0,
      klantNummer: 0,
      klantNaam: undefined,
      klantEanNummer: 0,
      klantGroepCode: undefined,
      klantGroepId: undefined,
      klantGroepOmschrijving: undefined,
      vestiging: globalVestiging,
      klantAfleverAfspraakId: 0,
      afleverAfspraakReferentie: undefined,
      klantgroepAfleverafspraakId: 0,
      mutatieDatumTijd: undefined,
      mutatieGebruiker: undefined,
      isVerwijderdIndicatie: false,
    }
    setHuidigeKoppeling(undefined)
    showDetail(nieuweKoppeling)
  }

  const handleOpslaan = () => {
    if (validateBeforeOpslaan()) {
      setOpgeslagen(true)
      postData(huidigeKoppeling)
    }
  }

  const validateBeforeOpslaan = (): boolean => {
    return (
      !!huidigeKoppeling.klantGroepId &&
      !!huidigeKoppeling.klantAfleverAfspraakId &&
      !!huidigeKoppeling.klantId
    )
  }

  const getDaysDisplay = (displayDays: string): string => {
    if (!displayDays) {
      return ''
    }

    const dayArray = displayDays
      .split(',')
      .map(d => +d)
      .sort((a, b) => (a === 0 ? 1 : a - b))

    if (dayArray.length === 7) {
      return 'Alle'
    } else {
      return dayArray.map(d => selectDay(d)).join(',')
    }
  }

  const getOrderTypesDisplay = (displayTypes: string): string => {
    if (!possibleOrderTypes || !displayTypes) {
      return displayTypes
    }

    const types = displayTypes
      .split(',')
      .map(t => +t)
      .sort((a, b) => a - b)

    if (possibleOrderTypes.length != types.length) {
      return displayTypes
    } else if (
      possibleOrderTypes.filter(t => !types.some(o => o === t.value)).length > 0
    ) {
      return displayTypes
    } else {
      return 'Alle'
    }
  }

  return (
    <div>
      {globalVestiging === undefined && <Redirect to='/home' />}
      <h2>Afleverafspraakreferenties klanten koppelen aan tijdvak</h2>

      <div>
        {(schermloading || loadingPossibleOrderTypes) && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <table className='selectie'>
          <thead>
            <tr>
              <th className='selectie-label'>Afleverafspraakreferentie:</th>
              <th className='selectie-label'>Klantnummer:</th>
              <th className='selectie-label'>Klantnaam:</th>
              <th className='selectie-label'>Vestiging:</th>
              <th className='selectie-label'>Tijdvak:</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr onKeyUp={e => zoekKlantGroepenIfEnter(e.key)}>
              <td>
                <input
                  type='text'
                  defaultValue={selectie.afleverAfspraakReferentie}
                  onChange={e => setAfleverAfspraakReferentie(e)}
                />
              </td>
              <td>
                <input
                  type='text'
                  maxLength={6}
                  defaultValue={selectie.klantNummer}
                  onChange={e => setKlantNummer(e)}
                />
              </td>
              <td>
                <input
                  value={selectie.klantNaam}
                  onChange={e => selectKlantNaam(e)}
                />
              </td>
              <td>{VestigingEnum[globalVestiging]}</td>
              <td>
                <SelectieButton
                  readonly={false}
                  type={'klantgroep'}
                  options={klantGroepen}
                  selected={selectie.klantGroepId}
                  onChange={e => setSelectieKlantgroep(e)}
                />
              </td>
              <td>
                <button className='btn btn-primary' onClick={zoekKlantGroepen}>
                  Zoek Koppelingen
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {!!foutmelding && (
        <div className='alter alert-danger maxedbox'>{foutmelding}</div>
      )}
      {koppelingen != null && (
        <div>
          <table className='selectie table-hover text-truncate'>
            <tbody>
              <tr className='tablesubheader'>
                <th>
                  <button
                    className='sortheader'
                    onClick={e =>
                      setSort(SortVolgordeEnum.AfleverafspraakReferentie)
                    }
                  >
                    <strong>Afleverafspraakreferentie</strong>
                  </button>
                </th>
                <th>
                  <button
                    className='sortheader'
                    onClick={e => setSort(SortVolgordeEnum.KlantNummer)}
                  >
                    <strong>Klantnr.</strong>
                  </button>
                </th>
                <th>
                  <button
                    className='sortheader'
                    onClick={e => setSort(SortVolgordeEnum.KlantEan)}
                  >
                    <strong>Klant EAN</strong>
                  </button>
                </th>
                <th>
                  <button
                    className='sortheader'
                    onClick={e => setSort(SortVolgordeEnum.KlantNaam)}
                  >
                    <strong>Klantnaam</strong>
                  </button>
                </th>
                <th>
                  <button
                    className='sortheader'
                    onClick={e => setSort(SortVolgordeEnum.Vestiging)}
                  >
                    <strong>Vestiging</strong>
                  </button>
                </th>
                <th>
                  <button
                    className='sortheader'
                    onClick={e => setSort(SortVolgordeEnum.KlantGroep)}
                  >
                    <strong>Tijdvak</strong>
                  </button>
                </th>
                <th>
                  <button
                    className='sortheader'
                    onClick={e => setSort(SortVolgordeEnum.MutatieDatumTijd)}
                  >
                    <strong>Gewijzigd op</strong>
                  </button>
                </th>
                <th>
                  <button
                    className='sortheader'
                    onClick={e => setSort(SortVolgordeEnum.MutatieGebruiker)}
                  >
                    <strong>Gewijzigd door</strong>
                  </button>
                </th>
              </tr>
              {renderRows(koppelingen)}
            </tbody>
          </table>
          <button className='btn btn-primary' onClick={handleNieuw}>
            Toevoegen Koppeling
          </button>
        </div>
      )}

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Koppeling Detail</Modal.Title>
        </Modal.Header>
        {schermloading && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <Modal.Body>
          {!!foutmelding && (
            <div className='alert alert-danger'>{foutmelding}</div>
          )}
          {huidigeKoppeling != null && huidigeKoppeling.klantNummer === 0 && (
            <table>
              <tbody>
                <tr>
                  <td>Klantnummer:</td>
                  <td>
                    <input
                      type='text'
                      maxLength={6}
                      defaultValue={zoekKlantNummer?.toString() ?? null}
                      onKeyUp={e => zoekKlantIfEnter(e.key)}
                      onChange={e => setDetailZoekKlantNummer(e)}
                    />
                  </td>
                  <td>
                    <button
                      className='btn btn-primary'
                      onClick={zoekKlant}
                      disabled={!zoekKlantNummer}
                    >
                      Zoek Klant
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          {huidigeKoppeling != null && huidigeKoppeling.klantNummer > 0 && (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Afleverafspraakreferentie</th>
                    <th>Klantnr.</th>
                    <th>KlantEAN</th>
                    <th>Vestiging</th>
                    <th>Tijdvak</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <SelectieButton
                        readonly={opgeslagen && foutmelding === ''}
                        type={'klantafleverafspraak'}
                        options={klantafleverafspraken}
                        selected={huidigeKoppeling.klantAfleverAfspraakId}
                        onChange={e => setDetailAfleverafspraakReferentie(e)}
                      />
                    </td>
                    <td>{huidigeKoppeling.klantNummer}</td>
                    <td>{huidigeKoppeling.klantEanNummer}</td>
                    <td>{VestigingEnum[huidigeKoppeling.vestiging]}</td>
                    <td>
                      <SelectieButton
                        readonly={opgeslagen && foutmelding === ''}
                        type={'klantgroep'}
                        options={klantGroepen}
                        selected={huidigeKoppeling.klantGroepId}
                        onChange={e => setDetailKlantgroep(e)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              {!!activeGroup && (
                <Table bordered>
                  <thead>
                    <tr>
                      <th
                        colSpan={6}
                        className='text-center'
                      >{`${activeGroup.klantGroepCode} - ${activeGroup.klantGroepOmschrijving}`}</th>
                    </tr>
                    <tr>
                      <th>Code</th>
                      <th>Doorlooptijd LDD</th>
                      <th>Aflevertijd LDD</th>
                      <th>Dagen</th>
                      <th>Ordertypes</th>
                      <th>Product</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{activeGroup.klantGroepCode}</td>
                      <td>
                        {activeGroup.lddLeadTimeAfterLSD
                          ? activeGroup.lddLeadTimeAfterLSD
                          : activeGroup.lddLeadTimeAfterEDD
                          ? activeGroup.lddLeadTimeAfterEDD
                          : '-'}
                      </td>
                      <td>{activeGroup.ldd ?? '-'}</td>
                      <td>{getDaysDisplay(activeGroup.dagen)}</td>
                      <td>{getOrderTypesDisplay(activeGroup.orderType)}</td>
                      <td>{activeGroup.productType}</td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {huidigeKoppeling != null &&
            huidigeKoppeling.klantGroepId !== undefined &&
            (!opgeslagen || foutmelding !== '') && (
              <Button variant='danger' onClick={handleDelete}>
                Verwijderen
              </Button>
            )}
          {huidigeKoppeling != null &&
            huidigeKoppeling.klantNaam !== undefined &&
            (!opgeslagen || foutmelding !== '') && (
              <Button
                variant='primary'
                onClick={handleOpslaan}
                disabled={!validateBeforeOpslaan()}
              >
                Opslaan
              </Button>
            )}
          <Button variant='secondary' onClick={handleClose}>
            Sluiten
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    schermloading: store.klantKoppelingState.loading,
    selectie: store.klantKoppelingState.selectie,
    koppelingen: store.klantKoppelingState.koppelingen,
    foutmelding: store.klantKoppelingState.foutmelding,
    koppelklant: store.klantKoppelingState.koppelklant,
    klantGroepen: store.klantKoppelingState.klantGroepen,
    klantafleverafspraken: store.klantKoppelingState.klantAfleverafspraken,
    alleklantGroepen: store.klantKoppelingState.alleKlantGroepen,
    globalVestiging: store.globalState.vestiging,
    possibleOrderTypes: store.globalState.possibleGroupLinkOrderTypes,
    loadingPossibleOrderTypes: store.globalState.loadingOrderTypes,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    getklantgroepen: (vestiging: VestigingEnum) =>
      dispatch(getKlantGroepenVestiging(vestiging)),
    getklantafleverafspraken: (vestiging: VestigingEnum, klantnummer: number) =>
      dispatch(getKlantAfleverafspraken(vestiging, klantnummer)),
    getklantgegevens: (klantnummer: number) =>
      dispatch(getKlantGegevens(klantnummer)),
    requestData: (selectie: IKlantSelectie) =>
      dispatch(getDataActionCreator(selectie)),
    postData: (klant: IKlantgroepAfleverafspraakModel) =>
      dispatch(postKlantGroepAfleverafspraakActionCreator(klant)),
    verwijderData: (klantgroep: IKlantgroepAfleverafspraakModel) =>
      dispatch(deleteKlantgroepAfleverafspraakActionCreator(klantgroep)),
    getPossibleOrderTypes: () => dispatch(getPossibleOrderTypesActionCreator()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KlantKoppelingenLijst)
